const portfolioObject = {
    offset: 6,
    isLoading: false,
    loadMoreButton: null,
    laodMoreButtonWrapper: null,
    newsContainer: null,
}


document.addEventListener('DOMContentLoaded', () => {
    const portfoliosWrapper = document.getElementById('portfoliosWrapper');

    if (!portfoliosWrapper){
        return;
    }

    const loadMoreButton = document.getElementById('loadMoreButton');

    // const newsArticlesWrapper = document.getElementById('newsArticlesWrapper');

    const buttonWrapper = document.getElementById('buttonWrapper');

    if (portfoliosWrapper) {
        portfolioObject.newsContainer = portfoliosWrapper;
    }

    if (buttonWrapper) {
        portfolioObject.laodMoreButtonWrapper = buttonWrapper;
    }

    if (loadMoreButton){
        portfolioObject.loadMoreButton = loadMoreButton;

        loadMoreButton.addEventListener('click', event => {
            if (portfolioObject.isLoading) {
                return;
            }

            loadMoreNews()
        })
    }
})


function loadMoreNews() {
    portfolioObject.isLoading = true;
    const ajaxUrl = ajax_object.ajax_url;
    const nonce = ajax_object.nonce;

    const data = new FormData();

    data.append('action', 'load_more_posts');
    data.append('nonce', ajax_object.nonce);
    data.append('offset', portfolioObject.offset);

    portfolioObject.loadMoreButton.classList.add('loading');

    const minDelay = new Promise(resolve => setTimeout(resolve, 800));

    Promise.all([
        fetch(ajaxUrl, {
            method: 'POST',
            body: data
        }),
        minDelay
    ])
        .then(([response]) => response.json())
        .then(data => {
            if (data.success) {

                // console.log(data);

                portfolioObject.newsContainer.innerHTML += data.data.html
                portfolioObject.offset = portfolioObject.offset + 6;

                if (!data.data.has_more) {
                    portfolioObject.laodMoreButtonWrapper.classList.add('!hidden');
                }

            } else {
                // console.error(data.data);
                // console.log(data)
            }
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
            portfolioObject.loadMoreButton.classList.remove('loading');
            portfolioObject.isLoading = false;
        })
}